import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DashboardOPEEnum} from "./DashboardOPEEnum";
import {WidgetEnum} from "../../components/widget/common/WidgetEnum";

class WidgetDTO {
  id!: number;
  name!: WidgetEnum;
  maxColsSize!: number;
  maxRowsSize!: number;
  minColsSize!: number;
  minRowsSize!: number;
  enabled!: boolean;
}

class O {
  widgets!: WidgetDTO[];
}

/**
 * O Inner Class
 */
class I {

}


/**
 * GetWidgetsCB class
 */
export class GetWidgetsCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DashboardOPEEnum.GetWidgets);
    this.i = new I();
    this.o = new O();
  }

}
